function getTarget(globalObject) {
  return globalObject || (typeof window !== "undefined" ? window : undefined);
}

export function getDownloadCapabilityStatus(globalObject) {
  const target = getTarget(globalObject);
  const features = {
    showDirectoryPicker: Boolean(
      target && typeof target.showDirectoryPicker === "function"
    ),
    FileSystemDirectoryHandle: Boolean(
      target && target.FileSystemDirectoryHandle
    ),
    FileSystemFileHandle: Boolean(target && target.FileSystemFileHandle),
    FileSystemWritableFileStream: Boolean(
      target && target.FileSystemWritableFileStream
    ),
    indexedDB: Boolean(target && target.indexedDB),
  };
  const missing = Object.keys(features).filter(
    (featureName) => !features[featureName]
  );

  return {
    supported: missing.length === 0,
    missing,
    features,
  };
}

export function getOrdinarySingleFileDownloadCapabilityStatus(globalObject) {
  const target = getTarget(globalObject);
  const supported = Boolean(
    target &&
      target.location &&
      typeof target.location.assign === "function"
  );

  return {
    supported,
    reason: supported
      ? ""
      : "Standard browser file downloads are not available.",
  };
}

export function getEnhancedDirectoryDownloadCapabilityStatus(globalObject) {
  const status = getDownloadCapabilityStatus(getTarget(globalObject));

  return {
    ...status,
    reason: status.supported
      ? ""
      : "Folder downloads with preserved hierarchy and resume require a supported desktop browser such as Chrome or Edge. Individual files can still be downloaded.",
  };
}
